export interface RealTimeSettingsState {
  MagEn: boolean;
  ELFEn: boolean;
  GeoEn: boolean;
  SendToDB: boolean;
  Freq1: number;
  PauseTime: number;
  SoundEn: boolean;
}

export interface GeoSpeedCalcSettingsState {
  Enable: boolean;
  WeldSpace: number;
  Metric: boolean;
  NumAvg: number;
  SourceRaw: boolean;
}

export interface GraphingSettingsState {
  ShowRaw: boolean;
  ShowMAG: boolean;
  ShowELF: boolean;
  EMExtents: string;
  RSSIExtents: string;
  GeoExtents: string;
}

export interface RealtimeStreamingState {
  RealTimeSettings: RealTimeSettingsState;
  GeoSpeedCalcSettings: GeoSpeedCalcSettingsState;
  GraphingSettings: GraphingSettingsState;
  RTStreamDialog: boolean;
  streamingUid: number | null;
}

export default {
  state: {
    RealTimeSettings: {
      MagEn: false,
      ELFEn: false,
      GeoEn: false,
      SendToDB: true,
      Freq1: 22,
      PauseTime: 30,
      SoundEn: false,
    },

    GeoSpeedCalcSettings: {
      Enable: false,
      WeldSpace: 40,
      Metric: false,
      NumAvg: 2,
      SourceRaw: true,
    },

    GraphingSettings: {
      ShowRaw: false,
      ShowMAG: true,
      ShowELF: true,
      EMExtents: 'extents',
      RSSIExtents: 'extents',
      GeoExtents: 'extents',
    },

    RTStreamDialog: false,
    streamingUid: null,
  } as RealtimeStreamingState,

  mutations: {
    SET_REALTIME_SETTINGS(
      state: RealtimeStreamingState,
      payload: Partial<RealTimeSettingsState>
    ) {
      Object.assign(state.RealTimeSettings, payload);
    },
    SET_GEO_SPEED_SETTINGS(
      state: RealtimeStreamingState,
      payload: Partial<GeoSpeedCalcSettingsState>
    ) {
      Object.assign(state.GeoSpeedCalcSettings, payload);
    },
    SET_GRAPHING_SETTINGS(
      state: RealtimeStreamingState,
      payload: Partial<GraphingSettingsState>
    ) {
      Object.assign(state.GraphingSettings, payload);
    },
    SET_RT_STREAM_DIALOG(state: RealtimeStreamingState, payload: boolean) {
      state.RTStreamDialog = payload;
    },
    SET_STREAMING_UID(state: RealtimeStreamingState, uid: number | null) {
      state.streamingUid = uid;
    },
  },

  actions: {
    // Signal-only actions: no state/mutations, used via subscribeAction for cross-component communication
    RealTimeOptionsShow(_context: any, _payload: any) {},
    UpdateGeoSpeedParams(_context: any, _payload: any) {},
    UpdateGraphing(_context: any, _payload: any) {},
    realtimeStreamerShow(_context: any, _payload: any) {},
  },
};
